import { FaroMenu, grey, type FaroMenuProps } from "@faro-lotv/flat-ui";
import { Skeleton, Stack } from "@mui/material";
import type { JSX } from "react/jsx-runtime";

export type LazyFaroMenuProps = FaroMenuProps & {
  /** Whether the FaroMenu is loading, and should show a skeleton */
  isLoading?: boolean;
};

/** @returns a FaroMenu that shows a skeleton when the isLoading prop is true */
export function LazyFaroMenu({
  isLoading,
  children,
  ...faroMenuProps
}: LazyFaroMenuProps): JSX.Element {
  return (
    <FaroMenu {...faroMenuProps}>
      {isLoading ? (
        <Stack sx={{ gap: 1 }}>
          <ContextMenuSkeletonLine />
          <ContextMenuSkeletonLine />
          <ContextMenuSkeletonLine />
        </Stack>
      ) : (
        children
      )}
    </FaroMenu>
  );
}

/** @returns a skeleton line for a context menu */
export function ContextMenuSkeletonLine(): JSX.Element {
  return (
    <Skeleton
      variant="text"
      sx={{
        fontSize: "1.2rem",
        lineHeight: "2rem",
        bgcolor: `${grey[500]}26`,
      }}
    />
  );
}
